import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { PageProps } from 'types/page'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { Providers } from 'experiences/providers'

const ProvidersPage: NextPage<PageProps> = ({ metaTags }): JSX.Element => {
	return (
		<>
			<StandardLayout metaTags={metaTags}>
				<Providers />
			</StandardLayout>
		</>
	)
}

export const getServerSideProps = defaultSSRProps

export default ProvidersPage
